import store from './../game/store/index.js';
import * as turf from "@turf/turf";

const zone = {
	install(Vue, options) {

		const $auth = Vue.prototype.$auth;
		const $geo = Vue.prototype.$geo;
		const $finder = Vue.prototype.$finder;

		Vue.prototype.$zone = {
			requiresVehicle(zone_id) {
				let zone = store.state.zones[zone_id];
				let vehicles = [...zone.vehicles];

				if (!vehicles) return false;

				$finder.remove(vehicles, 'transport');
				return vehicles.length;
			},
			get(zone_id) {
				return store.state.zones[zone_id];
			},
			getName(worker_id) {
				let worker = store.state.workers[worker_id];
				if (!worker) return null;
				if ($auth.hasAccess('worker.name')) {
					return worker.first_name+' '+worker.last_name;
				}

				return worker.badge_number;
			},
			findPath(origin, destination) {

			},
			getClosestParking(zone, max_distance, vehicle_type) {

				if (zone.parking_zones && zone.parking_zones[vehicle_type]) return store.state.zones[zone.parking_zones[vehicle_type]];

				let parking_zones = [];

				for (let i in store.state.zones) {
					let parking_zone = store.state.zones[i];
					// if (parking_zone.id == zone.id) continue;
					if (parking_zone.type == 'parking') {
						if (vehicle_type != 'transport' && !parking_zone.parking_vehicles.includes(vehicle_type)) {
							continue;
						}
						let shortLine = this.zonesAreClose(zone.id, parking_zone.id, max_distance);
						if (shortLine) {
							parking_zones.push({ 'zone': parking_zone, 'distance': shortLine.distance } );
						}
					}
				}

				if (parking_zones.length <= 0) return null;

				parking_zones = $finder.order(parking_zones, 'distance');
				if (zone.parking_zones == undefined) zone.parking_zones = {};
				zone.parking_zones[vehicle_type] = parking_zones[0].zone.id;

				return parking_zones[0].zone;
			},
			zonesAreClose(zone1_id, zone2_id, max_distance) {

				if (isNaN(zone1_id)) zone1_id = zone1_id.id;
				if (isNaN(zone2_id)) zone2_id = zone2_id.id;

				if (!max_distance) max_distance = 75;
				// console.log('zones are close? ', zone1_id, zone2_id);
				let zone1 = store.state.features[zone1_id];
				let zone2 = store.state.features[zone2_id];
				let geom1 = zone1.getGeometry();
				let geom2 = zone2.getGeometry();
				if (geom1.getType() == 'Circle') geom1 = new ol.geom.Polygon($geo.toOL(zone1.inner.geometry.coordinates))
				if (geom2.getType() == 'Circle') geom2 = new ol.geom.Polygon($geo.toOL(zone2.inner.geometry.coordinates))

				let shortestLine = $geo.getShortestLine(geom1, geom2);
				let shortestLineTurf = turf.lineString($geo.toTurf(shortestLine.getCoordinates()));
				let distance = turf.length(shortestLineTurf)*1000;
				if (max_distance == "*" || distance < parseFloat(max_distance)) return { 'line': shortestLine, 'turf': shortestLineTurf, 'distance': distance };
				return false;
			},
			zoneIsClose(zone_id, point, max_distance=75) {


				if (!max_distance) max_distance = 75;

				if (isNaN(zone_id)) zone_id = zone_id.id;
				point = new ol.geom.Point(point);

				let feature = store.state.features[zone_id];
				let geom1 = feature.getGeometry();

				let shortestLine = $geo.getShortestLine(point, geom1);
				let shortestLineTurf = turf.lineString($geo.toTurf(shortestLine.getCoordinates()));
				let distance = turf.length(shortestLineTurf)*1000;
				// console.log(distance);
				if (max_distance == "*" || distance < parseFloat(max_distance)) return { 'line': shortestLine, 'turf': shortestLineTurf, 'distance': distance };
				return false;
			}
		}
	}
};

export default zone;
